import moment from 'moment';
import { get } from '@/api/produit/produitReseauNumerique';
import {
  CATEGORIE_REGROUPEMENT_NUMERIQUE,
} from '@/configuration/catalogue/produitConf';
import { toSaturation } from '@/services/devisCommandes/numerique/saturationConvertisseur';

function calculeNombreDiffusionEcran(
  lignesCommande, informationRegroupement, arrayProduitReseauNumerique,
) {
  informationRegroupement.forEach((ligne) => {
    const reseauNumerique = arrayProduitReseauNumerique.find((el) => {
      return el.data.result.id === ligne.id;
    });
    if (reseauNumerique) {
      ligne.reseauNumerique = reseauNumerique.data.result;
      const nbEcransADate = reseauNumerique.data.result
        .produitReseauNumerique.affectationsReseauEcran
        .filter(a => (moment(ligne.dateDebut).isBetween(a.dateDebut, a.dateFin, 'day', '[]'))
          || (!a.dateFin && moment(ligne.dateDebut) > moment(a.dateDebut)));
      ligne.nbEcran = nbEcransADate.length;
      nbEcransADate.forEach((ecran) => {
        if (ecran.produit.produitEcranNumerique.outdoor !== null
          && ecran.produit.produitEcranNumerique.outdoor) {
          ligne.nbEcranOutdoor += 1;
        }
      });
      const ligneCommandeWithSameProduitId = lignesCommande.filter(
        ligneCommande => ligneCommande.produitId === ligne.id,
      );
      ligneCommandeWithSameProduitId.forEach((ligneToCalcul) => {
        if (toSaturation(ligneToCalcul.quantiteDispo) === 0) {
          ligne.nbDiffusion = 0;
        } else {
          ligne.nbDiffusion += ((moment(ligneToCalcul.dateFin).diff(
            ligneToCalcul.dateDebut, 'days',
          ) + 1) * reseauNumerique.data.result.produitReseauNumerique.nombreDiffusionJour
            / toSaturation(ligneToCalcul.quantiteDispo));
        }
      });
    }
  });
}

export default async function getInformationRegroupement(lignesCommande) {
  const informationRegroupement = [];
  const promises = [];
  for (let i = 0; i < lignesCommande.length; i += 1) {
    const ligne = lignesCommande[i];
    if (ligne.type !== 'Personnalise') {
      const produitDeLaLigne = informationRegroupement.find((el) => {
        return ligne.produitId === el.id;
      });
      if (produitDeLaLigne === undefined) {
        const newProduit = {
          id: ligne.produitId,
          reseauNumerique: null,
          nbEcran: 0,
          nbDiffusion: 0,
          nbEcranOutdoor: 0,
          libelle: ligne.libelle,
          produitCode: ligne.produit === null ? null : ligne.produit.reference,
          type: ligne.typeProduit,
          totalHt: 0,
        };
        lignesCommande.filter((el) => {
          return ligne.produitId === el.produitId;
        }).forEach((ligneCommande) => {
          newProduit.totalHt += ligneCommande.totalHt;
        });
        informationRegroupement.push(newProduit);
        if (newProduit.type === CATEGORIE_REGROUPEMENT_NUMERIQUE) {
          promises.push(get(newProduit.id));
        }
      }
    }
  }
  const responseProduitReseauNumerique = await Promise.all(promises);
  calculeNombreDiffusionEcran(lignesCommande, informationRegroupement,
    responseProduitReseauNumerique);
  return informationRegroupement;
}
